import './BasicPageLayout.css'

export type BasicPageLayoutProps = {
    height: string,
    content: JSX.Element,
    button: JSX.Element,
}

export function BasicPageLayout(props : BasicPageLayoutProps){
    return <div className="basic-page-layout" style={{height: props.height}}>
        <div className="basic-content">
            {props.content}
        </div>
        <div className="basic-page-button">
            <div className="small-margin">
                {props.button}
            </div>
        </div>
    </div>
}

export function BasicPageLayoutNoSubscript(props : BasicPageLayoutProps){
    return <div className="basic-page-layout-no-subscript" style={{height: props.height}}>
        <div className="basic-content">
            {props.content}
        </div>
        <div className="basic-page-button-no-subscript">
            <div className="small-margin">
                {props.button}
            </div>
        </div>
    </div>
}

export function BasicSubscript({text} : {text : string}) {
    return <div className="basic-subscript-outer flex-center full-size">
        <div className="basic-subscript">
            {text}
        </div>
    </div>;
}